const uniqueArray = (input: any[]) =>
  input.filter((value, index, self) => {
    return self.indexOf(value) === index;
  });

export default uniqueArray;
